export default __webpack_public_path__ + "static/media/TiesImg.32022424.jpg";